import { ReactElement, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = (): ReactElement | null => {
  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
